import { render, staticRenderFns } from "./CourseDetails2.vue?vue&type=template&id=526b0c08&scoped=true&"
import script from "./CourseDetails2.vue?vue&type=script&lang=js&"
export * from "./CourseDetails2.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetails2.vue?vue&type=style&index=0&id=526b0c08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b0c08",
  null
  
)

export default component.exports